import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from "./utilites";
const utils = new Utilitiesjs();

export default class ECommSession {

    async initAsync(opts) {
        this.customer = new ECommCustomer({
            session: this
        });
        this.paymentProvider = opts.paymentProvider || defaultPaymentProvider;
        return Promise.all([
            this.paymentProvider.initAsync(opts == null ? {} : opts.payment),
            this.customer.initAsync(opts == null ? {} : opts.customer)
        ]);
    }

    getCustomer() {
        return this.customer;
    }

    getPaymentProvider() {
        return this.paymentProvider;
    }
}

export class ECommCustomer {

    constructor(opts) {
        this.session = opts.session;
    }

    async initAsync(opts = {}) {
        return new Promise((res, rej) => {
            AgilityEComm.GetOrCreateSession(null, async customerKey => {
                this.customerKey = customerKey;
                if (opts.info != null) {
                    const info = { info: opts.info }; //new object in case opts.finally is set. Don't want to call twice, from updateInfo.
                    try {
                        await this.updateInfo(info);
                    } catch (ex) {
                        rej(ex);
                        return;
                    }
                    res();
                }
                else {
                    res();
                }
            }, rej, opts.finally);
        });
    }

    async updateInfo(opts = {}) {
        const info = opts.info;
        info.CustomerKey = this.customerKey;
        return new Promise((res, rej) => {
            AgilityEComm.Customer.Update(info, res, rej, opts.finally);
        });
    }

    async getInfoAsync(opts = {}) {
        return new Promise((res, rej) => {
            AgilityEComm.Customer.Get({ IncludeAddresses: true }, res, rej, opts.finally);
        });
    }

    async newOrderAsync(opts = {}) {
        if (this.order != null) this.order.dispose();
        this.order = new ECommOrder({
            session: this.session
        });
        await this.order.initAsync(opts);
        return this.order;
    }

    getOrder() {
        return this.order;
    }

}

export class ECommOrder {

    constructor(opts) {
        this.session = opts.session;
    }

    async initAsync(opts = {}) {
        return new Promise((res, rej) => {
            this.order = null;
            AgilityEComm.Order.Insert({
                CurrencyID: 2,
                Referrer: "CSCP",
                AdditionalJSON: opts.additionalJSON != null && typeof opts.additionalJSON != "string" ? JSON.stringify(opts.additionalJSON) : opts.additionalJSON
            }, order => {
                this.order = order;
                res(order);
            }, err => {
                rej(err);
            });
        });
    }

    getOrderNumber(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return this.order.OrderNumber;
    }

    async addItemAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return new Promise((res, rej) => {
            let item = {
                orderNumber: this.getOrderNumber(),
                productID: opts.variantID,
                productVariantMeasureID: opts.measureID,
                productDescription: opts.description,
                quantity: opts.quantity
            };
            if (opts.additionalJSON && typeof opts.additionalJSON != "string") {
                item.additionalJSON = JSON.stringify(opts.additionalJSON);
            }
            AgilityEComm.Order.UpdateItem(item, order => {
                this.order = order;
                res(order);
            }, rej, opts.finally);
        });
    }

    async addCustomPriceItemAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return new Promise((res, rej) => {
            AgilityEComm.Order.UpdateItem({
                orderNumber: this.getOrderNumber(),
                productID: opts.variantID,
                productVariantMeasureID: opts.measureID,
                productDescription: opts.description,
                quantity: opts.quantity,
                additionalJSON: JSON.stringify({ priceOverride: opts.priceOverride })
            }, order => {
                this.order = order;
                res(order);
            }, rej, opts.finally);
        });
    }

    async applyPromoAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return new Promise((res, rej) => {
            AgilityEComm.Order.ApplyPromo({
                orderNumber: this.getOrderNumber(),
                promoCode: opts.promoCode
            }, order => {
                this.order = order;
                res(order);
            }, rej, opts.finally);
        });
    }

    async removePromoAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return new Promise((res, rej) => {
            AgilityEComm.Order.RemovePromo({
                orderNumber: this.getOrderNumber(),
                promoCode: opts.promoCode
            }, order => {
                this.order = order;
                res(order);
            }, rej, opts.finally);
        });
    }

    async updateAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        let order = Object.assign({ OrderNumber: this.getOrderNumber(), CurrencyID: 2 }, opts.order);
        let formattedOrder = utils.enforceCamelCase(order);

        return new Promise((res, rej) => {
            AgilityEComm.Order.Update(formattedOrder,
                order => {
                    this.order = order;
                    res(order);
                }, rej, opts.finally);
        });
    }

    async setShippingAddressAsync(address) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return this.updateAsync({ order: { ShippingAddress: address } });
    }
    async setBillingAddressAsync(address) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return this.updateAsync({ order: { BillingAddress: address } });
    }
    async setAddressAsync(address) {
        return Promise.all([
            this.setShippingAddressAsync(address),
            this.setBillingAddressAsync(address)
        ]);
    }

    async getInfoAsync(opts = {}) {
        return new Promise((res, rej) => {
            AgilityEComm.Order.Get(this.getOrderNumber(), res, rej, opts.finally);
        });
    }

    async getCostsAsync() {
        const order = await this.getInfoAsync();
        return {
            Total: order.TotalValueMinorUnits / 100,
            Subtotal: order.SubTotalValueMinorUnits / 100,
            Promotional: order.TotalPromotionalValueMinorUnits / 100,
            AmountPaid: order.TotalAmountPaidMinorUnits / 100,
            Tax: order.TaxAmountMinorUnits / 100,
            Shipping: order.ShippingCostMinorUnits / 100
        }
    }

    requiresManualFulfillment() {
        return false;
    }

    async checkoutAsync(opts = {}) {
        if (this.invalid) {
            throw new Error("Order is Invalid");
            return;
        }
        return new Promise(async (res, rej) => {

            if (opts.address != null) await this.setAddressAsync(opts.address);
            if (opts.billingAddress != null) await this.setBillingAddressAsync(opts.billingAddress);
            if (opts.shippingAddress != null) await this.setShippingAddressAsync(opts.shippingAddress);

            let orderinfo = await this.getInfoAsync();
            let customerinfo = await this.session.getCustomer().getInfoAsync();

            const paymentProvider = this.session.getPaymentProvider();
            let orderData = {
                orderNumber: this.getOrderNumber(),
                paymentProviderReferenceName: paymentProvider.paymentProviderReferenceName,
                paymentTypeHash: null, //to be obtained from payment provider
                currencyID: 2, //todo
                taxAmountMinorUnits: 0, //todo
                taxDescription: "",
                shippingAmountMinorUnits: 0, //todo
                shippingDescription: "",
                billingAddressJson: orderinfo.BillingAddress == null ? null : JSON.stringify(orderinfo.BillingAddress),
                shippingAddressJson: orderinfo.ShippingAddress == null ? null : JSON.stringify(orderinfo.ShippingAddress),
                notes: opts.notes,
                useStoreCredits: true
            };

            const total = (await this.getCostsAsync()).Total;

            const paymentOpts = Object.assign({ customer: customerinfo }, { total, requiresManualFulfillment: this.requiresManualFulfillment() }, opts);
            const paymentToken = await paymentProvider.payAsync(paymentOpts).catch(function(e) {
                rej(e)
            });

            orderData.paymentTypeHash = paymentToken;
            AgilityEComm.Order.Checkout(orderData, result => {
                this.dispose();
                res(result);
            }, rej, opts.finally);

        });
    }

    dispose() {
        this.order = null;
        this.invalid = true;
    }
}


//Payment Providers
export class ECommPaymentProvider {
    constructor(opts) {
        this.paymentProviderReferenceName = opts.paymentProviderReferenceName;
    }
    async initAsync() { }
    async payAsync() { }
};

export class ECommStripePaymentProvider extends ECommPaymentProvider {

    constructor(opts = {}) {
        super(opts);
        this.stripeIframeArg = {
            referenceName: opts.paymentProviderReferenceName,
            elementID: "#" + (opts.id || "stripepayment"),
            options: {
                //set the element options: https://stripe.com/docs/stripe.js#element-options
                hidePostalCode: true
            },
            onCardValidateOK: (x) => {
            },
            onCardValidateError: (msg) => {
            }
        }
    }

    async initAsync() {
        return new Promise((res, rej) => {
            Agility.Ecommerce.API.PaymentProviders.Stripe.GetStripeIFrame(this.stripeIframeArg,
                (cardReturn) => {
                    this.stripeIframeCard = cardReturn;
                    res();
                }, (err) => {
                    rej(err);
                }, (x) => {
                }
            );
        });
    }

    async payAsync(data) {
        return new Promise((res, rej) => {
            const customer = data.customer;
            const addr = data.billingAddress || data.address;
            Agility.Ecommerce.API.PaymentProviders.Stripe.GetStripeTokenFromElements(this.stripeIframeCard,
                {
                    name: `${customer.FirstName} ${customer.LastName}`,
                    address_line1: addr.line1,
                    address_line2: addr.line2,
                    address_city: addr.city,
                    address_state: addr.state,
                    address_zip: addr.postalCode,
                    address_country: addr.country
                },
                res, rej
            );
        });
    }
};

export class ECommPaypalPaymentProvider extends ECommPaymentProvider {

    constructor(opts) {
        super(opts);
    }

    async initAsync() { }

    async payAsync(data) {
        return new Promise((res, rej) => {
            AgilityEComm.PaymentProviders.Paypal.GetPaymentToken({
                intent: data.requiresManualFulfillment ? 'authorize' : 'sale',
                currency: 'CAD',
                amount: data.total.toString(),
                shippingAddressEditable: false,
                shippingAddressOverride: data.shippingAddress || data.address
            }, res, rej);
        });
    }
};


// WEBPACK FOOTER //
// ./Scripts/es6/ecomm.js